import { imageLoader } from "next-image-loader/image-loader";

imageLoader.loader = ({ src, width, quality = 75 }) => {
  // To avoid appending width & quality attributes to seo image url containing seoimage keyword for FB to crawl properly
  if (src.includes("seoimage")) {
    return `${src}`;
  } else if (src.includes("assets.myundi.com.my")) {
    return `${src}?w=${width}&q=${quality}`;
  } else if (src.match("images.luminews.my")) {
    return src;
  } else if (src.match("image.luminews.my")) {
    return src;
  } else if (!src.match("images.luminews.my")) {
    return `${src}?w=${width}&q=${quality}`;
  }

  const relativeSrc = (src) => src.split("/").pop();

  return `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}/${relativeSrc(src)}`;
};
